import type { FC } from 'react';
import React from 'react';

import type { ForgeUISpaceSettingsExtensionType } from '@confluence/forge-ui';
import { getAppId, extensionTitle, ForgeKeyboardShortcutVisualizer } from '@confluence/forge-ui';
import { SPACE_SETTINGS_FORGE_APPS } from '@confluence/named-routes';

import { isForgeAppMatchingRoute } from '../helpers/webItem';

import { ANALYTICS_SOURCE as FORGE_ANALYTICS_SOURCE } from './ForgeAppsLoader';
import { TabItem } from './TabItem';
import type { BaseTabsProps } from './WebItemTabs';
import { ConditionalDropdownItemWrapper } from './WebItemTabs';

export type ForgeAppsProps = {
	spaceKey: string;
	forgeAppId?: string;
	forgeEnvId?: string;
	forgeRoutePath?: string;
};

export type ForgeAppTabsProps = BaseTabsProps &
	ForgeAppsProps & {
		apps: ForgeUISpaceSettingsExtensionType[];
	};

export const ForgeAppTabs: FC<ForgeAppTabsProps> = ({
	apps,
	setWidth,
	createClickEvent,
	forgeAppId,
	forgeEnvId,
	forgeRoutePath,
	spaceKey,
	isDropdown,
}) => (
	<>
		{apps.map((app: ForgeUISpaceSettingsExtensionType, index: number) => {
			const title = extensionTitle(app);
			const appId = getAppId(app);
			const isSelected = isForgeAppMatchingRoute(app, forgeAppId, forgeEnvId, forgeRoutePath);

			return (
				<ConditionalDropdownItemWrapper key={app.id} condition={isDropdown}>
					<ForgeKeyboardShortcutVisualizer module={app}>
						<TabItem
							key={app.id}
							label={title}
							isSelected={isSelected}
							href={SPACE_SETTINGS_FORGE_APPS.toUrl({
								spaceKey,
								appId,
								envId: app.environmentId,
								forgeManifestRoute: app.properties?.route,
							})}
							onClick={createClickEvent(getAppId(app), FORGE_ANALYTICS_SOURCE)}
							isDropdown={isDropdown}
							index={index}
							setWidth={setWidth}
						/>
					</ForgeKeyboardShortcutVisualizer>
				</ConditionalDropdownItemWrapper>
			);
		})}
	</>
);
